import type { Location } from 'history';

import type { WorkJourneyRealTimeLocationState } from '../locationState';
import type { RealTimeKpiKey } from './realTimeKpiFilters';

export const resolveInitialRealTimeKpi = (
  location: Pick<Location<WorkJourneyRealTimeLocationState | undefined>, 'state'>,
): RealTimeKpiKey | null => {
  const initialKpi = location.state?.initialKpi;
  return initialKpi === 'requiresAction' ? initialKpi : null;
};
